<template>
  <div>
    <vs-row class="mb-4">
      <vs-col>
        <h5>
          <i class="dot"></i>{{ $t('증상조사표') }}</h5>
      </vs-col>
    </vs-row>

    <!-- 1. -->
    <div class="px-2 py-5" style="font-size:16px; font-weight: 500;">{{ $t('1. 규칙적인(한번에 30분 이상, 1주일에 적어도 2-3회 이상) 여가 및 취미활동을 하고 계시는 곳에 표시하여 주십시오.') }}</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="print-checkbox"><i><feather-icon v-if="form.input1 && form.input1.indexOf('게임 등 컴퓨터 관련 활동') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('게임 등 컴퓨터 관련 활동') }}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input1 && form.input1.indexOf('피피아노, 드럼펫 등 악기연주') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('피피아노, 드럼펫 등 악기연주') }}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input1 && form.input1.indexOf('뜨개질, 붓글씨 등') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('뜨개질, 붓글씨 등') }}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input1 && form.input1.indexOf('테니스, 축구, 농구, 골프 등 스포츠 활동') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('테니스, 축구, 농구, 골프 등 스포츠 활동') }}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input1 && form.input1.indexOf('해당사항 없음') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('해당사항 없음') }}</span>
        </div>
        <div v-else class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <vs-checkbox class="mr-5 mb-2" v-model="form.input1" vs-value="게임 등 컴퓨터 관련 활동" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input1', '해당사항 없음')">{{ $t('게임 등 컴퓨터 관련 활동') }}</vs-checkbox>
          <vs-checkbox class="mr-5 mb-2" v-model="form.input1" vs-value="피피아노, 드럼펫 등 악기연주" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input1', '해당사항 없음')">{{ $t('피피아노, 드럼펫 등 악기연주') }}</vs-checkbox>
          <vs-checkbox class="mr-5 mb-2" v-model="form.input1" vs-value="뜨개질, 붓글씨 등" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input1', '해당사항 없음')">{{ $t('뜨개질, 붓글씨 등') }}</vs-checkbox>
          <vs-checkbox class="mr-5 mb-2" v-model="form.input1" vs-value="테니스, 축구, 농구, 골프 등 스포츠 활동" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input1', '해당사항 없음')">{{ $t('테니스, 축구, 농구, 골프 등 스포츠 활동') }}</vs-checkbox>
          <vs-checkbox class="mb-2" v-model="form.input1" vs-value="해당사항 없음" color="secondary" :disabled="readonly" @change="handleInitData('input1', '해당사항 없음')">{{ $t('해당사항 없음') }}</vs-checkbox>
        </div>
      </vs-col>
    </vs-row>

    <!-- 2. -->
    <div class="px-2 py-5" style="font-size:16px; font-weight: 500;">{{ $t('2. 귀하의 하루 평균 가사노동시간(밥하기, 빨래하기, 청소하기, 2살 미만의 아이 돌보기 등)은 얼마나 됩니까?') }}</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="print-radio"><i><feather-icon v-if="form.input2 && form.input2.indexOf('거의 하지 않는다.') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('거의 하지 않는다.') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input2 && form.input2.indexOf('1시간 미만') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('1시간 미만') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input2 && form.input2.indexOf('1-2시간 미만') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('1-2시간 미만') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input2 && form.input2.indexOf('2-3시간 미만') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('2-3시간 미만') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input2 && form.input2.indexOf('3시간 이상') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('3시간 이상') }}</span>
        </div>
        <div v-else class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <vs-radio class="mr-5 mb-2" v-model="form.input2" vs-value="거의 하지 않는다." color="secondary" :disabled="readonly">{{ $t('거의 하지 않는다.') }}</vs-radio>
          <vs-radio class="mr-5 mb-2" v-model="form.input2" vs-value="1시간 미만" color="secondary" :disabled="readonly">{{ $t('1시간 미만') }}</vs-radio>
          <vs-radio class="mr-5 mb-2" v-model="form.input2" vs-value="1-2시간 미만" color="secondary" :disabled="readonly">{{ $t('1-2시간 미만') }}</vs-radio>
          <vs-radio class="mr-5 mb-2" v-model="form.input2" vs-value="2-3시간 미만" color="secondary" :disabled="readonly">{{ $t('2-3시간 미만') }}</vs-radio>
          <vs-radio class="mb-2" v-model="form.input2" vs-value="3시간 이상" color="secondary" :disabled="readonly">{{ $t('3시간 이상') }}</vs-radio>
        </div>
      </vs-col>
    </vs-row>

    <!-- 3. -->
    <div class="px-2 py-5" style="font-size:16px; font-weight: 500;">{{ $t('3. 귀하는 의사로부터 다음과 같은 질병에 대해 진단을 받은 적이 있습니까?(해당 질병에 체크)') }}</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 grid" style="align-items: center;" >
          <div class="flex mb-4">
            <span class="print-radio"><i><feather-icon v-if="form.input3 && form.input3.indexOf('아니오') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('아니오') }}</span>
            <span class="print-radio"><i><feather-icon v-if="form.input3 && form.input3.indexOf('예') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>예</span>
            <span v-if="form.input3 === '${hIdx}|예'" class="mr-5" style="color:#696D71; font-weight: 400;">{{ $t("* '예'인 경우 현재상태는 ?") }}</span>
            <span v-if="form.input3 === '${hIdx}|예'" class="print-radio"><i><feather-icon v-if="form.input3_option1 && form.input3_option1.indexOf('완치') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('완치') }}</span>
            <span v-if="form.input3 === '${hIdx}|예'" class="print-radio"><i><feather-icon v-if="form.input3_option1 && form.input3_option1.indexOf('치료나 관찰중') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('치료나 관찰중') }}</span>
          </div>
          <div v-if="form.input3 === '${hIdx}|예'" class="flex">
            <span class="print-checkbox"><i><feather-icon v-if="form.input3_option2 && form.input3_option2.indexOf('류머티스 관절염') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('류머티스 관절염') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input3_option2 && form.input3_option2.indexOf('당뇨병') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('당뇨병') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input3_option2 && form.input3_option2.indexOf('통풍') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('통풍') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input3_option2 && form.input3_option2.indexOf('알코올중독') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('알코올중독') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input3_option2 && form.input3_option2.indexOf('해당사항 없음') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('해당사항 없음') }}</span>
          </div>
        </div>
        <div v-else class="w-full px-2 mb-4 grid" style="align-items: center;" >
          <div class="flex mb-4">
            <vs-radio class="mr-5" v-model="form.input3" vs-value="${hIdx}|아니오" color="secondary" :disabled="readonly">{{ $t('아니오') }}</vs-radio>
            <vs-radio class="mr-8" v-model="form.input3" vs-value="${hIdx}|예" color="secondary" :disabled="readonly">예</vs-radio>
          </div>
          <div v-if="form.input3 === '${hIdx}|예'" class="mb-4">
            <div class="option-container">
              <span class="option-label mb-2">{{ $t("* '예'인 경우 현재상태는 ?") }}</span>
              <div class="option-group">
                <vs-radio class="mr-5" v-model="form.input3_option1" vs-value="완치" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)">{{ $t('완치') }}</vs-radio>
                <vs-radio v-model="form.input3_option1" vs-value="치료나 관찰중" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)">{{ $t('치료나 관찰중') }}</vs-radio>
              </div>
            </div>
          </div>
          <div v-if="form.input3 === '${hIdx}|예'" class="option-checkbox-group">
            <vs-checkbox class="mr-5 mb-2" v-model="form.input3_option2" vs-value="류머티스 관절염" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)" @change="handleRemoveDefault('input3_option2', '해당사항 없음')">{{ $t('류머티스 관절염') }}</vs-checkbox>
            <vs-checkbox class="mr-5 mb-2" v-model="form.input3_option2" vs-value="당뇨병" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)" @change="handleRemoveDefault('input3_option2', '해당사항 없음')">{{ $t('당뇨병') }}</vs-checkbox>
            <vs-checkbox class="mr-5 mb-2" v-model="form.input3_option2" vs-value="통풍" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)" @change="handleRemoveDefault('input3_option2', '해당사항 없음')">{{ $t('통풍') }}</vs-checkbox>
            <vs-checkbox class="mr-5 mb-2" v-model="form.input3_option2" vs-value="알코올중독" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)" @change="handleRemoveDefault('input3_option2', '해당사항 없음')">{{ $t('알코올중독') }}</vs-checkbox>
            <vs-checkbox class="mb-2" v-model="form.input3_option2" vs-value="해당사항 없음" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)" @change="handleInitData('input3_option2', '해당사항 없음')">{{ $t('해당사항 없음') }}</vs-checkbox>
          </div>
        </div>
      </vs-col>
    </vs-row>

    <!-- 4. -->
    <div class="px-2 py-5" style="font-size:16px; font-weight: 500;">{{ $t('4. 과거에 운동 중 혹은 사고(교통사고, 넘어짐, 추락 등)로 인해 손/손가락/손목, 팔/팔꿈치, 어깨, 목, 허리, 다리/발 부위를 다친 적인 있습니까 ?') }}</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="print-radio"><i><feather-icon v-if="form.input4 && form.input4.indexOf('아니오') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('아니오') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input4 && form.input4.indexOf('예') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>예</span>
          <span v-if="form.input4 === '4|예'" class="mr-5" style="color:#696D71; font-weight: 400;">{{ $t("* '예'인 경우 상해 부위는 ?") }}</span>
          <span v-if="form.input4 === '4|예'" class="print-checkbox"><i><feather-icon v-if="form.input4_option && form.input4_option.indexOf('손/손가락/손목') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('손/손가락/손목') }}</span>
          <span v-if="form.input4 === '4|예'" class="print-checkbox"><i><feather-icon v-if="form.input4_option && form.input4_option.indexOf('팔/팔꿈치') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('팔/팔꿈치') }}</span>
          <span v-if="form.input4 === '4|예'" class="print-checkbox"><i><feather-icon v-if="form.input4_option && form.input4_option.indexOf('어깨') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('어깨') }}</span>
          <span v-if="form.input4 === '4|예'" class="print-checkbox"><i><feather-icon v-if="form.input4_option && form.input4_option.indexOf('목') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>목</span>
          <span v-if="form.input4 === '4|예'" class="print-checkbox"><i><feather-icon v-if="form.input4_option && form.input4_option.indexOf('허리') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('허리') }}</span>
          <span v-if="form.input4 === '4|예'" class="print-checkbox"><i><feather-icon v-if="form.input4_option && form.input4_option.indexOf('다리/발') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('다리/발') }}</span>
        </div>
        <div v-else class="w-full px-2 mb-4 grid" style="align-items: center;" >
          <div class="flex mb-4">
            <vs-radio class="mr-5" v-model="form.input4" vs-value="4|아니오" color="secondary" :disabled="readonly">{{ $t('아니오') }}</vs-radio>
            <vs-radio class="mr-8" v-model="form.input4" vs-value="4|예" color="secondary" :disabled="readonly">예</vs-radio>
          </div>
          <div v-if="form.input4 === '4|예'" class="option-group-label mb-2">
            <span style="color:#696D71; font-weight: 400;">{{ $t("* '예'인 경우 상해 부위는 ?") }}</span>
          </div>
          <div v-if="form.input4 === '4|예'" class="option-checkbox-group">
            <vs-checkbox class="mr-5 mb-2" v-model="form.input4_option" vs-value="손/손가락/손목" color="secondary" :disabled="(form.input4 !== '4|예'||readonly)">{{ $t('손/손가락/손목') }}</vs-checkbox>
            <vs-checkbox class="mr-5 mb-2" v-model="form.input4_option" vs-value="팔/팔꿈치" color="secondary" :disabled="(form.input4 !== '4|예'||readonly)">{{ $t('팔/팔꿈치') }}</vs-checkbox>
            <vs-checkbox class="mr-5 mb-2" v-model="form.input4_option" vs-value="어깨" color="secondary" :disabled="(form.input4 !== '4|예'||readonly)">{{ $t('어깨') }}</vs-checkbox>
            <vs-checkbox class="mr-5 mb-2" v-model="form.input4_option" vs-value="목" color="secondary" :disabled="(form.input4 !== '4|예'||readonly)">목</vs-checkbox>
            <vs-checkbox class="mr-5 mb-2" v-model="form.input4_option" vs-value="허리" color="secondary" :disabled="(form.input4 !== '4|예'||readonly)">{{ $t('허리') }}</vs-checkbox>
            <vs-checkbox class="mb-2" v-model="form.input4_option" vs-value="다리/발" color="secondary" :disabled="(form.input4 !== '4|예'||readonly)">{{ $t('다리/발') }}</vs-checkbox>
          </div>
        </div>
      </vs-col>
    </vs-row>
    <!-- 5. -->
    <div class="px-2 py-5" style="font-size:16px; font-weight: 500;">{{ $t('5. 현재 하시는 일의 육체적 부담 정도는 어느 정도라고 생각 합니까 ?') }}</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="print-radio"><i><feather-icon v-if="form.input5 && form.input5.indexOf('전혀 힘들지 않음') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('전혀 힘들지 않음') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input5 && form.input5.indexOf('견딜만 함') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('견딜만 함') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input5 && form.input5.indexOf('약간 힘듦') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('약간 힘듦') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input5 && form.input5.indexOf('힘듦') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('힘듦') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input5 && form.input5.indexOf('매우 힘듦') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('매우 힘듦') }}</span>
        </div>
        <div v-else class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <vs-radio class="mr-5 mb-2" v-model="form.input5" vs-value="전혀 힘들지 않음" color="secondary" :disabled="readonly">{{ $t('전혀 힘들지 않음') }}</vs-radio>
          <vs-radio class="mr-5 mb-2" v-model="form.input5" vs-value="견딜만 함" color="secondary" :disabled="readonly">{{ $t('견딜만 함') }}</vs-radio>
          <vs-radio class="mr-5 mb-2" v-model="form.input5" vs-value="약간 힘듦" color="secondary" :disabled="readonly">{{ $t('약간 힘듦') }}</vs-radio>
          <vs-radio class="mr-5 mb-2" v-model="form.input5" vs-value="힘듦" color="secondary" :disabled="readonly">{{ $t('힘듦') }}</vs-radio>
          <vs-radio class="mb-2" v-model="form.input5" vs-value="매우 힘듦" color="secondary" :disabled="readonly">{{ $t('매우 힘듦') }}</vs-radio>
        </div>
      </vs-col>
    </vs-row>

    <div class="px-2 py-5 my-4" style="border-bottom: 1px solid #CDCDCD;  font-size:16px; font-weight: 500; page-break-before: always; ">{{ $t('II. 지난 1년 동안 손/손가락/손목, 팔/팔꿈치, 어깨, 목, 허리, 다리/발 중 어느 한 부위에서라도 귀하의 작업과 관련하여 통증이나 불편함(통증, 쑤시는 느낌, 뻣뻣함, 화끈거리는 느낌, 무감각 혹은 찌릿찌릿함 등)을 느끼신 적이 있습니까 ?') }}</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 grid" style="align-items: center;" >
          <span class="print-radio mb-4"><i><feather-icon v-if="form.input6 && form.input6.indexOf('6|아니오') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('아니오(수고하셨습니다. 설문을 다 마치셨습니다.)') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input6 && form.input6.indexOf('6|예') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('예("예"라고 답하신 분은 아래 표의 통증부위에 체크하고, 해당 통증부위의 세로줄로 내려가며 해당사항에 체크해 주십시오)') }}</span>
        </div>
        <div v-else class="w-full px-2 mb-4 grid" style="align-items: center;" >
          <vs-radio class="mr-5 mb-4" v-model="form.input6" vs-value="6|아니오" color="secondary" :disabled="readonly">{{ $t('아니오(수고하셨습니다. 설문을 다 마치셨습니다.)') }}</vs-radio>
          <vs-radio class="mr-8" v-model="form.input6" vs-value="6|예" color="secondary" :disabled="readonly"><span style="line-height: 1.4">{{ $t('예("예"라고 답하신 분은 아래 표의 통증부위에 체크하고, 해당 통증부위의 세로줄로 내려가며 해당사항에 체크해 주십시오)') }}</span></vs-radio>
        </div>

        <div v-if="isPrint && form.input6 === '6|예'" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="mr-5" style="color:#696D71; font-weight: 400;">{{ $t("* '예'인 경우 상해 부위는 ?") }}</span>
          <span v-for="key in checkHeads" :key="key" class="print-checkbox"><i><feather-icon v-if="form.input6_option1 && form.input6_option1.indexOf(key) >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{key}}</span>
        </div>
        <div v-else-if="form.input6 === '6|예'" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="mr-5" style="color:#696D71; font-weight: 400;">{{ $t("* '예'인 경우 상해 부위는 ?") }}</span>
          <vs-checkbox v-for="key in checkHeads" :key="key" class="mr-5 mb-2" v-model="form.input6_option1" :vs-value="key" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{key}}</vs-checkbox>
        </div>

        <div v-if="form.input6 === '6|예'" class="check-table" :class="[isMobile ? 'mobile-card-layout': 'pc-card-layout']">
          <template v-if="!isMobile">
          <vs-row >
            <vs-col>{{ $t('통증부위') }}</vs-col>
            <vs-col>
              <div v-for="head in checkTableHeads" :key="head" class="table-border">{{  head  }}</div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>{{ $t('1. 통증의 구체적 부위는?') }}</vs-col>
            <vs-col>
              <div v-for="head in checkTableHeads" :key="head" class="table-border" :data-title="head">
                <div v-if="head === '목' || head === '허리'">-</div>
                <div v-else-if="isPrint" >
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][0].indexOf(`${head}-${0}|오른쪽`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('오른쪽') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][0].indexOf(`${head}-${0}|왼쪽`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('왼쪽') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][0].indexOf(`${head}-${0}|양쪽 모두`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('양쪽 모두') }}</span>
                </div>
                <div v-else>
                  <vs-radio v-model="form.input6_option2[head][0]" :vs-value="`${head}-${0}|오른쪽`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('오른쪽') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][0]" :vs-value="`${head}-${0}|왼쪽`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('왼쪽') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][0]" :vs-value="`${head}-${0}|양쪽 모두`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('양쪽 모두') }}</vs-radio>
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>{{ $t('2. 한번 아프기 시작하면 통증 기간은 얼마 동안 지속됩니까?') }}</vs-col>
            <vs-col>
              <div v-for="head in checkTableHeads" :key="head" class="table-border" :data-title="head">
                <div v-if="isPrint">
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][1].indexOf(`${head}-${1}|1일 미만`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('1일 미만') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][1].indexOf(`${head}-${1}|1일 - 1주일 미만`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('1일 - 1주일 미만') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][1].indexOf(`${head}-${1}|1주일 - 1달 미만`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('1주일 - 1달 미만') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][1].indexOf(`${head}-${1}|1달 - 6개월 미만`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('1달 - 6개월 미만') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][1].indexOf(`${head}-${1}|6개월 이상`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('6개월 이상') }}</span>
                </div>
                <div v-else >
                  <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|1일 미만`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('1일 미만') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|1일 - 1주일 미만`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('1일 - 1주일 미만') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|1주일 - 1달 미만`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('1주일 - 1달 미만') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|1달 - 6개월 미만`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('1달 - 6개월 미만') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|6개월 이상`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('6개월 이상') }}</vs-radio>
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col class="flex flex-col">{{ $t('3. 그때의 아픈 정도는 어느 정도 입니까 ?') }}<div class="flex w-full p-0" style="color:#7E72F2; justify-content: start">
                <vx-tooltip
                  v-if="!isPrint"
                  title="통증 기준표?"
                  :html="$t('자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요')"
                  style="
                    cursor: pointer;
                    margin-left: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                  position="top"
                  delay=".1s"
                >
                  <feather-icon
                    icon="AlertCircleIcon"
                    style="
                      width: 18px;
                      color: #7e72f2;
                      margin-right: 3px;
                    "
                    @click="onClickToolTip()"
                  />
                  <span @click="onClickToolTip()">{{ $t('통증 기준표') }}</span>
                </vx-tooltip>
              </div>
            </vs-col>
            <vs-col>
              <div v-for="head in checkTableHeads" :key="head" class="table-border" :data-title="head">
                <div v-if="isPrint">
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][2].indexOf(`${head}-${2}|약한 통증`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('약한 통증') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][2].indexOf(`${head}-${2}|중간 통증`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('중간 통증') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][2].indexOf(`${head}-${2}|심한 통증`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('심한 통증') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][2].indexOf(`${head}-${2}|매우 심한 통증`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('매우 심한 통증') }}</span>
                </div>
                <div v-else>
                  <vs-radio v-model="form.input6_option2[head][2]" :vs-value="`${head}-${2}|약한 통증`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('약한 통증') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][2]" :vs-value="`${head}-${2}|중간 통증`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('중간 통증') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][2]" :vs-value="`${head}-${2}|심한 통증`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('심한 통증') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][2]" :vs-value="`${head}-${2}|매우 심한 통증`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('매우 심한 통증') }}</vs-radio>
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>{{ $t('4. 지난 1년 동안 이러한 증상을 얼마나 자주 경험하셨습니까 ?') }}</vs-col>
            <vs-col>
              <div v-for="head in checkTableHeads" :key="head" class="table-border">
                <div v-if="isPrint">
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][3].indexOf(`${head}-${3}|6개월에 1번`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('6개월에 1번') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][3].indexOf(`${head}-${3}|2-3달에 1번`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('2-3달에 1번') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][3].indexOf(`${head}-${3}|1달에 1번`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('1달에 1번') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][3].indexOf(`${head}-${3}|1주일에 1번`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('1주일에 1번') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][3].indexOf(`${head}-${3}|매일`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('매일') }}</span>
                </div>
                <div v-else>
                  <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|6개월에 1번`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('6개월에 1번') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|2-3달에 1번`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('2-3달에 1번') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|1달에 1번`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('1달에 1번') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|1주일에 1번`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('1주일에 1번') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|매일`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('매일') }}</vs-radio>
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>{{ $t('5. 지난 1주일 동안에도 이러한 증상이 있었습니까 ?') }}</vs-col>
            <vs-col>
              <div v-for="head in checkTableHeads" :key="head" class="table-border">
                <div v-if="isPrint">
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][4].indexOf(`${head}-${4}|아니요`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('아니요') }}</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][4].indexOf(`${head}-${4}|예`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>예</span>
                </div>
                <div v-else>
                  <vs-radio v-model="form.input6_option2[head][4]" :vs-value="`${head}-${4}|아니요`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('아니요') }}</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][4]" :vs-value="`${head}-${4}|예`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">예</vs-radio>
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>{{ $t('6. 지난 1년 동안 이러한 통증으로 인해 어떤 일이 있었습니까 ?') }}</vs-col>
            <vs-col>
              <div v-for="head in checkTableHeads" :key="head" class="table-border">
                <div v-if="isPrint">
                  <span class="print-checkbox"><i><feather-icon v-if="form.input6_option2 && form.input6_option2[head][5].indexOf('병원․한의원 치료') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('병원․한의원 치료') }}</span>
                  <span class="print-checkbox"><i><feather-icon v-if="form.input6_option2 && form.input6_option2[head][5].indexOf('약국치료') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('약국치료') }}</span>
                  <span class="print-checkbox"><i><feather-icon v-if="form.input6_option2 && form.input6_option2[head][5].indexOf('병가, 산재') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('병가, 산재') }}</span>
                  <span class="print-checkbox"><i><feather-icon v-if="form.input6_option2 && form.input6_option2[head][5].indexOf('작업 전환') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('작업 전환') }}</span>
                  <span class="print-checkbox"><i><feather-icon v-if="form.input6_option2 && form.input6_option2[head][5].indexOf('해당사항 없음') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('해당사항 없음') }}</span>
                  <span class="print-input">{{form.input6_option2[head][6]}}</span>
                </div>
                <div v-else>
                  <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="병원․한의원 치료" color="secondary" :disabled="readonly" @change="handleRemoveDefaultWithCheckTable(head, 5, '해당사항 없음')">{{ $t('병원․한의원 치료') }}</vs-checkbox>
                  <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="약국치료" color="secondary" :disabled="readonly" @change="handleRemoveDefaultWithCheckTable(head, 5, '해당사항 없음')">{{ $t('약국치료') }}</vs-checkbox>
                  <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="병가, 산재" color="secondary" :disabled="readonly" @change="handleRemoveDefaultWithCheckTable(head, 5, '해당사항 없음')">{{ $t('병가, 산재') }}</vs-checkbox>
                  <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="작업 전환" color="secondary" :disabled="readonly" @change="handleRemoveDefaultWithCheckTable(head, 5, '해당사항 없음')">{{ $t('작업 전환') }}</vs-checkbox>
                  <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="해당사항 없음" color="secondary" :disabled="readonly" @change="handleInitDataWithCheckTable(head, 5, '해당사항 없음')">{{ $t('해당사항 없음') }}</vs-checkbox>
                  <ml-input class="w-full" v-model="form.input6_option2[head][6]" :readonly="(form.input6_option2[head][5][0] !== '해당사항 없음' || form.input6 !== '6|예'||readonly)"/>
                </div>
              </div>
            </vs-col>
          </vs-row>
          </template>

          <!-- 모바일 카드 레이아웃 -->
          <template v-else>
            <div class="mobile-pain-cards">
              <div v-for="head in checkTableHeads" :key="head" class="pain-card">
                <div class="pain-card-header">
                  <h3>{{ head }}</h3>
                </div>
                <div class="pain-card-body">
                  <!-- 1. 통증의 구체적 부위 -->
                  <div class="pain-question-group" v-if="head !== '목' && head !== '허리'">
                    <h4>{{ $t('1. 통증의 구체적 부위는?') }}</h4>
                    <div class="pain-options">
                      <vs-radio v-model="form.input6_option2[head][0]" :vs-value="`${head}-${0}|오른쪽`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('오른쪽') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][0]" :vs-value="`${head}-${0}|왼쪽`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('왼쪽') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][0]" :vs-value="`${head}-${0}|양쪽 모두`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('양쪽 모두') }}</vs-radio>
                    </div>
                  </div>
                  <div class="pain-question-group" v-else>
                    <h4>{{ $t('1. 통증의 구체적 부위는?') }}</h4>
                    <div class="pain-options">-</div>
                  </div>

                  <!-- 2. 통증 기간 -->
                  <div class="pain-question-group">
                    <h4>{{ $t('2. 통증 기간은 얼마 동안 지속됩니까?') }}</h4>
                    <div class="pain-options">
                      <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|1일 미만`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('1일 미만') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|1일 - 1주일 미만`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('1일 - 1주일 미만') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|1주일 - 1달 미만`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('1주일 - 1달 미만') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|1달 - 6개월 미만`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('1달 - 6개월 미만') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|6개월 이상`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('6개월 이상') }}</vs-radio>
                    </div>
                  </div>

                  <!-- 3. 아픈 정도 -->
                  <div class="pain-question-group">
                    <h4>{{ $t('3. 그때의 아픈 정도는 어느 정도 입니까?') }}<div class="pain-tooltip">
                        <vx-tooltip
                          v-if="!isPrint"
                          title="통증 기준표?"
                          :html="$t('자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요')"
                          style="cursor: pointer;"
                          position="top"
                          delay=".1s"
                        >
                          <feather-icon
                            icon="AlertCircleIcon"
                            style="width: 18px; color: #7e72f2; margin-right: 3px;"
                            @click="onClickToolTip()"
                          />
                          <span @click="onClickToolTip()">{{ $t('통증 기준표') }}</span>
                        </vx-tooltip>
                      </div>
                    </h4>
                    <div class="pain-options">
                      <vs-radio v-model="form.input6_option2[head][2]" :vs-value="`${head}-${2}|약한 통증`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('약한 통증') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][2]" :vs-value="`${head}-${2}|중간 통증`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('중간 통증') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][2]" :vs-value="`${head}-${2}|심한 통증`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('심한 통증') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][2]" :vs-value="`${head}-${2}|매우 심한 통증`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('매우 심한 통증') }}</vs-radio>
                    </div>
                  </div>

                  <!-- 4. 증상 경험 빈도 -->
                  <div class="pain-question-group">
                    <h4>{{ $t('4. 지난 1년 동안 이러한 증상을 얼마나 자주 경험하셨습니까?') }}</h4>
                    <div class="pain-options">
                      <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|6개월에 1번`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('6개월에 1번') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|2-3달에 1번`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('2-3달에 1번') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|1달에 1번`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('1달에 1번') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|1주일에 1번`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('1주일에 1번') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|매일`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('매일') }}</vs-radio>
                    </div>
                  </div>

                  <!-- 5. 최근 증상 여부 -->
                  <div class="pain-question-group">
                    <h4>{{ $t('5. 지난 1주일 동안에도 이러한 증상이 있었습니까?') }}</h4>
                    <div class="pain-options">
                      <vs-radio v-model="form.input6_option2[head][4]" :vs-value="`${head}-${4}|아니요`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{ $t('아니요') }}</vs-radio>
                      <vs-radio v-model="form.input6_option2[head][4]" :vs-value="`${head}-${4}|예`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">예</vs-radio>
                    </div>
                  </div>

                  <!-- 6. 통증으로 인한 일 -->
                  <div class="pain-question-group">
                    <h4>{{ $t('6. 지난 1년 동안 이러한 통증으로 인해 어떤 일이 있었습니까?') }}</h4>
                    <div class="pain-options checkbox-group">
                      <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="병원․한의원 치료" color="secondary" :disabled="readonly" @change="handleRemoveDefaultWithCheckTable(head, 5, '해당사항 없음')">{{ $t('병원․한의원 치료') }}</vs-checkbox>
                      <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="약국치료" color="secondary" :disabled="readonly" @change="handleRemoveDefaultWithCheckTable(head, 5, '해당사항 없음')">{{ $t('약국치료') }}</vs-checkbox>
                      <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="병가, 산재" color="secondary" :disabled="readonly" @change="handleRemoveDefaultWithCheckTable(head, 5, '해당사항 없음')">{{ $t('병가, 산재') }}</vs-checkbox>
                      <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="작업 전환" color="secondary" :disabled="readonly" @change="handleRemoveDefaultWithCheckTable(head, 5, '해당사항 없음')">{{ $t('작업 전환') }}</vs-checkbox>
                      <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="해당사항 없음" color="secondary" :disabled="readonly" @change="handleInitDataWithCheckTable(head, 5, '해당사항 없음')">{{ $t('해당사항 없음') }}</vs-checkbox>
                      <ml-input class="w-full mt-2" v-model="form.input6_option2[head][6]" :readonly="(form.input6_option2[head][5][0] !== '해당사항 없음' || form.input6 !== '6|예'||readonly)"/>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </template>
        </div>
      </vs-col>
    </vs-row>

    <popup-alert v-model="alert.show"
                 :title="alert.title"
                 :html="alert.html"
                 :buttons="alert.buttons"
    ></popup-alert>
  </div>
</template>

<script>
import PopupAlert from '@/popup/PopupAlert'
export default {
  name: 'SymptomInvestigationTable',
  components: {PopupAlert},
  props: {
    isPrint: Boolean,
    value: Object,
    readonly: Boolean,
  },
  computed: {
    checkHeads () {
      return Object.keys(this.form.input6_option2)
    },
    checkTableHeads () {
      const keys = Object.keys(this.form.input6_option2)
      const heads = []

      for (const key of keys) {
        if (this.form.input6_option1 && this.form.input6_option1.indexOf(key) >= 0) {
          heads.push(key)
        }
      }
      return heads
    },
    $vssWidth() {
      return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    },
    isMobile() {
      return this.$vssWidth < 768;
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data () {
    return {
      alert: {
        show: false,
        title: '통증 기준표',
        html:
          '<div style="width: 100%; max-width: 540px; padding: 24px;">' +
            `<p class="mb-1" style="font-size: 16px;"><b>{{ $t('약한 통증 :') }}</b>{{ $t('약간 불편한 정도이나 작업에 열중할 때는 못 느낀다') }}</p>` +
            `<p class="mb-1" style="font-size: 16px;"><b>{{ $t('중간 통증 :') }}</b>{{ $t('작업 중 통증이 있으나 귀가 후 휴식을 취하면 괜찮다') }}</p>` +
            `<p class="mb-1" style="font-size: 16px;"><b>{{ $t('심한 통증 :') }}</b>{{ $t('작업 중 통증이 비교적 심하고 귀가 후에도 통증이 계속된다') }}</p>` +
            `<p style="font-size: 16px;"><b>{{ $t('매우 심한 통증 :') }}</b>{{ $t('통증 때문에 작업은 물론 일상생활을 하기가 어렵다') }}</p>` +
          '</div>',
        buttons: []
      },
      form: {
        input1: ['해당사항 없음'],
        input2: {},
        input3: '',
        input3_option1: '',
        input3_option2: ['해당사항 없음'],
        input4: '',
        input4_option: [],
        input5: '',
        input6: '',
        input6_option1: [],
        input6_option2: {
          '목': ['', '', '', '', '', []],
          '어깨': ['', '', '', '', '', []],
          '손/손가락/손목': ['', '', '', '', '', []],
          '팔/팔꿈치': ['', '', '', '', '', []],
          '허리': ['', '', '', '', '', []],
          '다리/발': ['', '', '', '', '', []],
        }
      }
    }
  },
  methods: {
    onClickToolTip () {
      this.alert.show = true
    },

    handleInitData (key, str) {
      if (typeof this.form[key] === 'object') {
        if (this.form[key].length > 0) {
          this.form[key] = [str]
        }
      } else if (typeof this.form[key] === 'string') {
        if (this.form[key]) {
          this.form[key] = str
        }
      }
    },

    handleRemoveDefault (key, str) {
      if (typeof this.form[key] === 'object') {
        const index = this.form[key].indexOf(str)
        if (index === 0 && this.form[key].length === 2) {
          this.form[key] = this.form[key].removeIndex(index)
        }
      } else if (typeof this.form[key] === 'string') {
        //this.form[key] = str
      }
    },


    handleInitDataWithCheckTable (key1, key2, str) {
      if (this.form.input6_option2[key1][key2] && this.form.input6_option2[key1][key2].length > 0) {
        this.form.input6_option2[key1][key2] = [str]
      }
    },

    handleRemoveDefaultWithCheckTable (key1, key2, str) {
      const index = this.form.input6_option2[key1][key2].indexOf(str)
      if (index === 0 && this.form.input6_option2[key1][key2].length === 2) {
        this.form.input6_option2[key1][key2] = this.form.input6_option2[key1][key2].removeIndex(index)
        this.form.input6_option2[key1][6] = ''
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.check-table {
  border-top: 1px solid #CDCDCD;
  border-left: 1px solid #CDCDCD;
  & > .vs-row {
    display: grid !important;
    grid-template-columns: 165px 1fr;

    .vs-col {
      border-right: 1px solid #CDCDCD;
      border-bottom: 1px solid #CDCDCD;
    }
    .vs-col:first-child {
      width: 165px;
    }
    .vs-col:last-child {
      display: flex;

      & > div {
        width: 100%;
        display: flex;
        justify-content: center;

        & > div {
          width: 100%;
          max-width: 165px;
          display: grid;
          grid-template-columns: 1fr;
          justify-content: center;
          align-items: center;
          gap: 0.875rem;

          text-align: center;
          & > .vs-radio { width: 100%;}
          .checkbox_x.vs-checkbox { min-width:20px; min-height: 20px;}
        }
      }
    }
  }

  .table-border{
    border-right: 1px solid #CDCDCD;
    &:last-child{
      border-right: 0;
    }
  }

  /* 배경색상 */
  & > .vs-row:first-child,
  & > .vs-row > div:first-child {
    background: #F9F9F9;
    color: #3C3C3C;
    font-weight: 500;
  }

  /* 패딩 */
  & > .vs-row > .vs-col > div,
  & > .vs-row > div:first-child {
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

/* 모바일 카드 레이아웃 스타일 */
.mobile-card-layout {
  border: none;

  .mobile-pain-cards {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .pain-card {
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    margin-bottom: 16px;
    width: 100%;
    max-width: 100%;
  }

  .pain-card-header {
    background-color: #f5f5f5;
    padding: 12px 16px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    align-items: center;

    h3 {
      margin: 0;
      color: #333;
      font-size: 16px;
      font-weight: 600;
      width: 100%;
      text-align: center;
    }
  }

  .pain-card-body {
    padding: 16px;
  }

  .pain-question-group {
    margin-bottom: 20px;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }

    h4 {
      margin: 0 0 12px 0;
      font-size: 14px;
      color: #555;
      font-weight: 500;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
    }

    .pain-tooltip {
      display: inline-flex;
      margin-left: 8px;
      align-items: center;
    }
  }

  .pain-options {
    padding-left: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    &.checkbox-group {
      gap: 12px;
    }

    .vs-radio, .vs-checkbox {
      margin-bottom: 0;
      width: 100%;
      display: flex;
      align-items: center;
    }
  }
}

@media screen and (max-width: 768px) {
  /* 모바일에서 추가적인 카드 레이아웃 스타일 */
  .mobile-card-layout {
    border: none !important;
    box-shadow: none !important;
    margin-top: 0 !important;

    .pain-card {
      margin-left: 0;
      margin-right: 0;
      width: 100%;
    }
  }

  /* 기존 스타일 유지 */
  /* 제목 영역 스타일 개선 */
  h5 {
    font-size: 1rem !important;
    margin: 0.75rem 0 1rem 0.25rem;
    font-weight: 600;
  }

  /* 질문 제목 영역 */
  .px-2.py-5 {
    padding: 1rem 0.5rem !important;
    font-size: 15px !important;
    font-weight: 500 !important;
    line-height: 1.5 !important;
    background-color: #f9f9f9;
    border-radius: 4px;
    margin-bottom: 0.75rem;
  }

  /* 모바일 뷰에서 체크박스 컨테이너를 세로로 표시 */
  .w-full.px-2.mb-4.flex {
    flex-direction: column;
    align-items: flex-start !important;
    margin-bottom: 1.5rem !important;
    padding: 0.5rem 0.75rem !important;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    .vs-checkbox, .vs-radio {
      margin-bottom: 1rem;
      height: 1.75rem;
      display: flex;
      align-items: center;
    }

    /* 마지막 체크박스는 하단 마진 없음 */
    .vs-checkbox:last-child, .vs-radio:last-child {
      margin-bottom: 0;
    }
  }

  /* 그리드 컨테이너 스타일 개선 */
  .w-full.px-2.mb-4.grid {
    padding: 0.5rem 0.75rem !important;
    margin-bottom: 1.5rem !important;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    .flex.mb-4 {
      margin-bottom: 1rem !important;
    }
  }

  /* 통증조사표 테이블 모바일 최적화 */
  .check-table.pc-card-layout {
    font-size: 0.9rem;
    border: 1px solid #e2e2e2;
    border-radius: 4px;
    margin-top: 1.5rem;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    > div {
      display: block;

      > div:first-child {
        background-color: #f5f5f5;
        border-bottom: 1px solid #e2e2e2;
        font-weight: 600;
        color: #333;
      }

      > div:nth-child(2) {
        display: block;

        > div {
          padding: 1rem 0.75rem;
          border-bottom: 1px solid #e2e2e2;
          background-color: #ffffff;

          /* 상단에 제목 표시 */
          &:before {
            content: attr(data-title);
            display: block;
            font-weight: 600;
            margin-bottom: 0.75rem;
            padding-bottom: 0.5rem;
            text-align: left;
            color: #333;
            border-bottom: 1px dashed #e2e2e2;
          }

          /* 마지막 항목은 하단 보더 없음 */
          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }

  /* 라디오 버튼과 체크박스 스타일 개선 */
  .vs-radio, .vs-checkbox {
    margin-right: 1rem;
    margin-bottom: 0.75rem;
    min-height: 1.75rem;
    display: flex;
    align-items: center;
  }

  /* print-radio, print-checkbox 모바일 최적화 */
  .print-radio, .print-checkbox {
    display: block;
    margin-bottom: 0.75rem;
    padding: 0.25rem 0;
  }

  /* 큰 제목 영역 (II. 지난 1년 동안...) */
  .px-2.py-5.my-4 {
    padding: 1rem 0.75rem !important;
    margin: 2rem 0 1.5rem 0 !important;
    font-size: 15px !important;
    line-height: 1.5 !important;
    background-color: #f0f0f0;
    border-radius: 4px;
    border-bottom: 2px solid #cdcdcd !important;
  }

  /* 이미 체크된 부분의 스타일 개선 */
  .feather-icon {
    margin-right: 0.5rem;
  }
}

.print-radio,
.print-checkbox {
  display: flex;
  align-items: center;
  margin-right: 1rem;

  & > i { width: 20px; height: 20px; border: 2px solid #cdcdcd; position: relative; margin-right: 6px; }
  & .feather-icon { transform: translateY(-4px); }
}

.print-radio {
  & > i { border-radius: 20px; }
}

</style>
